import { render, staticRenderFns } from "./DossierMenu.vue?vue&type=template&id=fc853164&"
import script from "./DossierMenu.vue?vue&type=script&lang=js&"
export * from "./DossierMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports